module.exports = __webpack_public_path__ + "img/zs_7@2x.c47a0260.png";